import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { LocatorReducer } from "./reducers/LocatorsReducers";
import { ScrewReducer } from "./reducers/ScrewsReducers";
import { DatasetReducer } from "./reducers/DatasetReducer";
import { PredictionReducer } from "./reducers/PredictionReducers";
import customerUploadReducer from "./reducers/CustomerUploadReducer";

export const store = configureStore({
  reducer: {
    LocatorReducer,
    ScrewReducer,
    DatasetReducer,
    PredictionReducer,
    customerUpload: customerUploadReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
